import { createSlice, isAnyOf } from "@reduxjs/toolkit";

import loginApi from "../api/login";
import { LoginResponse, UserDetailModel } from "../types";

const initialState = {
  isLoggedIn: false,
} as LoginState;

const slice = createSlice({
  name: "login",
  initialState,
  reducers: {
    onSignOut: () => {
      return {
        ...initialState,
      };
    },
    updateUserDetail: (state, { payload }: { payload: UserDetailModel }) => {
      return { ...state, userDetail: { ...state.userDetail, ...payload } };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        loginApi.endpoints.authenticateUser.matchFulfilled,
        loginApi.endpoints.externalLogin.matchFulfilled
      ),
      (state, { payload }: { payload: LoginResponse }) => {
        return { ...payload, isLoggedIn: true };
      }
    );
  },
});

export const { onSignOut, updateUserDetail } = slice.actions;

export const login = slice.reducer;

export interface LoginState extends LoginResponse {
  isLoggedIn: boolean;
}
